export const ROLES = ['Admin', 'Owner', 'Manager', 'Staff'] as const;

export type RoleName = (typeof ROLES)[number];

export const ALL_ROLES: readonly RoleName[] = ROLES;
export const STAFF_ABOVE: readonly RoleName[] = ['Admin', 'Owner', 'Manager'];
export const OWNER_ABOVE: readonly RoleName[] = ['Admin', 'Owner'];
